import { VendorRentalApprovalListPage } from "@/features/vendor-consignment-rental-payment/pages/VendorRentalApprovalListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/vendor-rental-approval/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["vendor_consignment.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: VendorRentalApprovalListPage,
});
